import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import {
  Appointment,
  HomeCareDetail,
  TeleconsultationAppointmentDetail,
} from "@customTypes/appointment";
import { Pagination, SortBy } from "@customTypes/index";

import { appointmentQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Partial<Appointment>[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        doctor_assigned,
        created_at,
        appointment_date,
        consultation_id,
        details,
        category,
      } = res.data.data[i];

      if (category === "teleconsultation") {
        newData.push({
          id: _id,
          doctorAssigned: {
            id: doctor_assigned?._id,
            fullName: doctor_assigned?.full_name,
          },
          consultationId: consultation_id ?? "",
          createdAt: new Date(created_at),
          appointmentDate: new Date(appointment_date),
          category,
          details: {
            city: details?.t_city,
            serviceTypeId: details?.t_service_type_id,
            serviceType: details?.t_service_type,
            paymentMethod: details?.t_payment_method,
          } as TeleconsultationAppointmentDetail,
        });
      } else if (category === "homecare") {
        newData.push({
          id: _id,
          doctorAssigned: {
            id: doctor_assigned?._id,
            fullName: doctor_assigned?.full_name,
          },
          consultationId: consultation_id ?? "",
          createdAt: new Date(created_at),
          appointmentDate: new Date(appointment_date),
          category,
          details: {
            city: details?.city,
            zone: details?.zone,
            serviceTypeId: details?.service_type_id,
            serviceType: details?.service_type,
            paymentMethod: details?.payment_method,
          } as HomeCareDetail,
        });
      }
    }

    // console.log(newData);
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  consultationId: string;
  pagination?: Partial<Pagination>;
  isEnabled?: boolean;
  fields?: string[];
  sortBy?: SortBy;
}

export const useGetFollowUpAppointmentsForConsultation = ({
  isEnabled = true,
  pagination,
  consultationId,
  fields,
  sortBy = "desc",
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: appointmentQKeys.followUpForConsultation(consultationId),
    queryFn: () => {
      return api.get("appointments/", {
        params: {
          consultation_id: consultationId,
          is_follow_up: true,
          order_by: sortBy,
          ...(fields?.length && { fields: fields.join(",") }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Follow Up Appointments For Patient]", res);
      handleErrors(res, "query");
    },
  });
};
